import { lazy } from 'react';
import ComponentLoader from 'src/components/ComponentLoader';
import Module from 'src/config/models/Module';
import ModuleBundle from 'src/config/models/ModuleBundle';

export const InventoryCachingViewModule = new Module({
  id: 'INVENTORY-CACHING:VIEW:RESULT-TABLE',
  name: 'Inventory',
  label: 'Inventory',
  path: 'inventory',
  Component: ComponentLoader(
    lazy(() => import('src/content/management/InventoryCaching/View'))
  ),
  actions: {
    adjustStock: {
      id: 'INVENTORY-CACHING:VIEW:RESULT-TABLE',
      name: 'ADJUST_STOCK',
      label: 'Adjust Stock'
    },
    viewTransactions: {
      id: 'INVENTORY-CACHING:VIEW:RESULT-TABLE',
      name: 'VIEW_TRANSACTIONS',
      label: 'View Transactions'
    }
  }
});

export const StockTransferModule = new Module({
  id: 'INVENTORY-CACHING:STOCK-TRANSFER',
  name: 'Stock Transfer',
  label: 'Stock Transfer',
  path: 'inventory/stock-transfer',
  Component: ComponentLoader(
    lazy(() => import('src/content/management/InventoryCaching/StockTransfer'))
  )
});

const InventoryCachingModules = [InventoryCachingViewModule, StockTransferModule];

export default new ModuleBundle('InventoryCaching', InventoryCachingModules);
